export interface QuickWebTokenRequest {
    customerReferenceNumber: string;
    returnUrl: string;
    cancelUrl: string;
    supplierBusinessCode: string;
    partner: string;
    principalAmount?: number;
    paymentReference?: string;
}

export type NormalizedQuickWebTokenResponse = {
    statusCode: number;
    token: string;
    exception?: unknown;
};

export enum ResponseMapperType {
    QT = 'QT',
    CSP = 'CSP'
}

export const QTResponseMapper = (res: {
    statusCode: number;
    payLoad: string;
    exception: unknown;
}) => ({
    statusCode: res.statusCode,
    token: res.payLoad,
    exception: res.exception
});

export const CSPResponseMapper = (res: {
    statusCode: number;
    responseObject: string;
    message: unknown;
    isSuccessResponse: boolean;
}) => ({
    statusCode: res.statusCode,
    token: res.responseObject
});


export const responseMapperMap = {
    [ResponseMapperType.QT]: QTResponseMapper,
    [ResponseMapperType.CSP]: CSPResponseMapper
};
export interface WestpacRedirectParameters {
    token: string;
    formUrl: string;
    communityCode: string;
    customerReferenceNumber: string
};

export type TokenResponseMapper<TRaw = any> = (raw: TRaw) => NormalizedQuickWebTokenResponse;

declare global {
    interface Window {
        registerCallback?: (name: string) => any;
    }
}